var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path, _rect1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 225,
    viewBox: "0 0 87 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.238,
    y: 0.338,
    width: 33.517,
    height: 3.831,
    rx: 1.915,
    fill: "#666971"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.238,
    y: 29.067,
    width: 33.517,
    height: 3.831,
    rx: 1.915,
    fill: "#666971"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.238,
    y: 45.347,
    width: 63.204,
    height: 3.831,
    rx: 1.915,
    fill: "#666971"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.238,
    y: 62.584,
    width: 18.195,
    height: 3.831,
    rx: 1.915,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.238,
    y: 92.271,
    width: 44.051,
    height: 3.831,
    rx: 1.915,
    fill: "#666971"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.238,
    y: 109.509,
    width: 75.654,
    height: 3.831,
    rx: 1.915,
    fill: "#666971"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.238,
    y: 126.746,
    width: 51.713,
    height: 3.831,
    rx: 1.915,
    fill: "#666971"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.238,
    y: 156.433,
    width: 50.755,
    height: 3.831,
    rx: 1.915,
    fill: "#666971"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.238,
    y: 173.671,
    width: 41.178,
    height: 3.831,
    rx: 1.915,
    fill: "#666971"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.238,
    y: 203.358,
    width: 18.195,
    height: 3.831,
    rx: 1.915,
    fill: "#666971"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E1E3",
    d: "M.238 15.66h86.188v.958H.238zM.238 78.864h86.188v.958H.238zM.238 143.984h86.188v.958H.238zM.238 190.908h86.188v.958H.238z"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.238,
    y: 220.595,
    width: 28.729,
    height: 3.831,
    rx: 1.915,
    fill: "#666971"
  })));
};
export default SvgMenu;